'use client';

import { useState, useCallback } from 'react';
import type { DeviceOrientedComponentProps } from '../../../types';
import type { FaqItemNode } from 'data-layer';
import { FaqItem } from './FaqItem';

export interface FaqItemListProps extends DeviceOrientedComponentProps {
  items: FaqItemNode[];
  articleInternalName?: string;
}

/**
 * FaqItemList Component (Client Component)
 *
 * Manages the accordion state for a collection of FAQ items.
 * Only one item can be expanded at a time.
 */
export function FaqItemList(props: FaqItemListProps) {
  const { items, articleInternalName, device } = props;
  const [expanded, setExpanded] = useState<number | undefined>(undefined);

  const handleToggle = useCallback((index: number) => {
    setExpanded(prevExpanded => (prevExpanded === index ? undefined : index));
  }, []);

  return (
    <div className="faq-module__collapses">
      {items.map((item, index) => (
        <FaqItem
          key={item.id || `faq-item-${index}`}
          item={item}
          index={index}
          articleInternalName={articleInternalName}
          isExpanded={expanded === index}
          onToggle={handleToggle}
          device={device}
        />
      ))}
    </div>
  );
}
